import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const revertir = async (id, data) => {
  return await axiosIns.post(obtenerUrl(`reversiones-detalles-solicitudes/${id}/revertir`), data);
};

export default {
  revertir,
};
